//@flow
import { useMediaQuery } from "@mui/material";
import React, { useContext, useEffect } from 'react';
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import useMenuAction from "../../../../hooks/menu/useMenuAction";
import useMenuData from "../../../../hooks/menu/useMenuData";
import useConfig from "../../../../hooks/theme/useConfig";
import Drawer from "../drawer/drawer";
import Header from "../header/header";
import { useTheme } from "@mui/material/styles";

const MenuWithDrawer = (props) => {
	const theme = useTheme();
	const { drawerOpen } = useMenuData()
	const { setDrawerOpen } = useMenuAction()
	const { miniDrawer } = useConfig();
	const matchDownLG = useMediaQuery(theme.breakpoints.down('lg'));
	const downSM = useMediaQuery(theme.breakpoints.down('sm'));
	const isHome = window.location.pathname === "/"
	
	// set media wise responsive drawer
	useEffect(() => {
		if (!miniDrawer && drawerOpen) {
			setDrawerOpen(!matchDownLG)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [matchDownLG]);
	
	return (
		<Box>
			<Box sx={{ width: '100%', display: 'flex' }}>
				<Header/>
				<Drawer/>
				<Box
					component="main"
					sx={{
						flexGrow: 1,
						p: 2,
						pt: downSM ? 6 : 4,
						overflowX: 'auto'
					}}
				>
					<Toolbar variant={"dense"}/>
					{props.children}
				</Box>
			</Box>
		</Box>
	
	)
}

export default MenuWithDrawer;